<script>
export default {
	props:[
		'r_settings',
	],
	computed:{
		path_to_home: function(){
			if(this.r_settings &&
				this.r_settings["path_to_home"]){
				return this.r_settings["path_to_home"];
			}
			return "";
		},
		url_current: function(){
			return this.path_to_home + this.r_settings.url;
		},
		url_root: function(){
			return this.path_to_home + this.r_settings.baseUrl;
		},
		url_login: function(){
			return this.path_to_home + "login";
		},
		url_logout: function(){
			return this.path_to_home + "logout";
		},
	},
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/common/url.mixin.vue